import Item from './item'

interface IItemsProps {
    moneyPools: Array<MoneyPool>
}
export default function MoneyPools({ moneyPools }: IItemsProps) {
    return (
        <div>
            {moneyPools.map((item, index) => (
                <Item item={item} key={item.id} />
            ))}
        </div>
    )
}
